import { Form, Formik } from 'formik';

import { Modal } from '@shared/components/modals/Modal';

import { parentStepFormValidationSchema } from '../../constants';
import { IParentStepModalProps, TParentStepFormState } from '../../types';
import { ParentStepModalForm } from './ParentStepModalForm';

export const ParentStepModal = ({
  handleClose,
  handleSubmit,
  currentStep,
  selectedWorkflow,
  parentStepModalPosition,
}: IParentStepModalProps<TParentStepFormState>) => {
  const initialEditStepState: TParentStepFormState = {
    id: currentStep?.id || null,
    parentWorkflowStepId: currentStep?.parentWorkflowStepId || null,
  };

  return (
    <Modal 
      open
      hideBackdrop
      resetPosition={parentStepModalPosition}
      title="Edit Parent Step"
      dialogWidth="1000px" 
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        initialValues={initialEditStepState}
        validationSchema={parentStepFormValidationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <ParentStepModalForm
              handleClose={handleClose}
              currentStep={currentStep}
              selectedWorkflow={selectedWorkflow}
              {...props}
            />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
